import { IBeneficiosPlanoSaude } from '@core/models';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppState } from '@store/store';

interface IBeneficiosPlanoSaudeState {
    data: IBeneficiosPlanoSaude;
    loading: boolean;
    error: string | null;
}

const initialState: IBeneficiosPlanoSaudeState = {
    data: {} as IBeneficiosPlanoSaude,
    loading: false,
    error: null
};

export const beneficiosPlanoSaudeSlice = createSlice({
    name: 'beneficiosPlanoSaude',
    initialState,
    reducers: {
        beneficiosPlanoSaude_fetching: (state) => {
            state.loading = true;
            state.data = {} as IBeneficiosPlanoSaude;
            state.error = null;
        },
        beneficiosPlanoSaude_success: (state, action: PayloadAction<IBeneficiosPlanoSaude>) => {
            state.error = null;
            state.loading = false;
            state.data = action.payload;
        },
        beneficiosPlanoSaude_error: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.loading = false;
            state.data = {} as IBeneficiosPlanoSaude;
        }
    }
});

export const { beneficiosPlanoSaude_fetching, beneficiosPlanoSaude_success, beneficiosPlanoSaude_error } = beneficiosPlanoSaudeSlice.actions;

export const selectorPlanoSaude = (state: AppState) => state.beneficiosPlanoSaude;

export default beneficiosPlanoSaudeSlice.reducer;
